module.exports = __webpack_public_path__ + "static/media/projectImg.28a260ce.png";